import { Lang } from '../../../../../../types/global';
import { ProductRankingQueryParams } from './validate';
import { createProductRankingSearchParams } from './createProductRankingSearchParams';

export const generateProductRankingUrl = (lang: Lang['lang'], query: ProductRankingQueryParams): string => {
  const basePath = `/${lang}/@/product_ranking`;
  const searchParams = createProductRankingSearchParams(query);
  const queryString = searchParams.toString();

  return queryString ? `${basePath}?${queryString}` : basePath;
};
